import type { SourcingEventDto } from "../../../autogen/bff-api";

// SourcingEventDto.toDto keeps `award` after a withdrawal to carry the decision history, with `awardedAt` cleared.
export const hasStandingAwardDecision = (event: SourcingEventDto): boolean => event.award?.awardedAt != null;
